<cx-carousel
  [items]="items$ | async"
  [title]="title$ | async"
  [template]="carouselItem"
  itemWidth="285px"
>
</cx-carousel>

<ng-template #carouselItem let-item="item">
  <a tabindex="0" [routerLink]="{ cxRoute: 'product', params: item } | cxUrl">
    <cx-media
      [container]="item.images?.PRIMARY"
      format="product"
      [alt]="item.name"
    ></cx-media>
    <h3>
      {{ item.name }}
    </h3>
    <div class="price">
      {{ item.price?.formattedValue }}
    </div>
  </a>
</ng-template>
